"use strict";
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var matching_1 = require("./matching");
var scoring_1 = require("./scoring");
var time_estimates_1 = require("./time_estimates");
var feedback_1 = require("./feedback");
var zxcvbn = function (password, user_inputs) {
    // reset the user inputs matcher on a per-request basis to keep things stateless
    var sanitized_inputs = (user_inputs !== null && user_inputs !== void 0 ? user_inputs : [])
        .filter(function (input) { return ['string', 'number', 'boolean'].includes(typeof input); })
        .map(function (input) { return input.toLowerCase(); });
    matching_1.default.set_user_input_dictionary(sanitized_inputs);
    var matches = matching_1.default.omnimatch(password);
    var result = scoring_1.default.most_guessable_match_sequence(password, matches);
    var score = time_estimates_1.default.estimate_attack_times(result.guesses).score;
    return __assign(__assign({}, result), { score: score, feedback: feedback_1.default.get_feedback(score, result.sequence) });
};
exports.default = zxcvbn;
//# sourceMappingURL=main.js.map